import { ResourceGroupBase } from '../../resource_group_base'

/**
 * Deposits.
 *
 * @class
 */
export class Deposits extends ResourceGroupBase {
  /**
   * Set deposit state.
   *
   * @param {state} depositId Deposit ID.
   * @param {string} newState New deposit state.
   *
   * @return {JsonApiResponse}
   */
  setState (depositId, newState) {
    return this._makeCallBuilder()
      .appendUrlSegment(depositId)
      .withCredentials()
      .patch({
        data: {
          type: 'deposits',
          attributes: {
            state: newState
          }
        }
      })
  }

  _makeCallBuilder () {
    return this._server._makeCallBuilder()
      .appendUrlSegment('deposits')
      .withCredentials()
  }
}
